(ns frontend.view.modals.stage-delete.view
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.actions.stages :as stage-actions]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.view.modals.components.processing-modal :as processing-modal]
   [ui.color :as c]
   [ui.components.input.checkbox :as checkbox]
   [ui.components.modal.view :as modal]
   [ui.editors.labelled-input.view :as labelled-input]))

(defonce modal-key :stage-delete-modal)

(defn update!
  [state k val]
  (swap! state assoc-in [:edit k] val))

(defn select-stage-view
  [state stage]
  (let [pipeline-id (:stage/pipeline stage)
        stages (->> @session/stages
                    (remove (fn [s]
                              (= s stage)))
                    (cu/filter-by :stage/pipeline pipeline-id)
                    (sort-by :common/ord))
        value (get-in @state [:edit :new-stage])
        options (->> stages
                     (map (fn [a]
                            {:value (:db/id a)
                             :label (entity/display-string a)}))
                     (sort-by :label))]
    [:div
     [labelled-input/view
      {:editor-type :editor.type/select
       :options     options
       :value       (->> options
                         (cu/filter-by :value value)
                         (first))
       :placeholder (loc/tr :select)
       :on-change   (fn [new-value]
                      (update! state :new-stage new-value))}]]))

(defn view-body
  [state stage-id]
  (let [stage (get @session/entities stage-id)
        reassignment-required? (:reassignment/required? @state)]
    [:div
     (when reassignment-required?
       [:div
        {:class "flex flex-col gap-4"}
        [:span {:class "text-bold"}
         (loc/tr :stage-select-new
                 [(:reassignment/count @state) (:stage/name stage)])]
        [select-stage-view state stage]])
     [:p
      {:class "py-4 flex items-center gap-3"}
      [:label
       {:class "flex items-center gap-3 cursor-pointer"}
       [checkbox/view
        {:value     (-> @state
                        :confirmed?
                        boolean)
         :on-change #(swap! state update :confirmed? not)}]

       [:span
        (loc/tr :i-understand-theres-no-undo-for-this)]]]
     ]))

(defn handle-delete-error!
  [state e]
  (if (= :stage-reassignment-required
         (get-in e [:client-friendly-error-data :reason]))
    (swap! state (fn [s]
                   (-> s
                       (assoc :reassignment/required? true)
                       (assoc :reassignment/count
                              (get-in e [:client-friendly-error-data :count]))
                       (dissoc :process/status))))
    (do
      (logging/error "failed to delete stage" e)
      (swap! state assoc :process/status :process.status/failed))))

(defn delete!
  [state stage-id _on-close!]
  (let [new-stage-id (-> @state
                         :edit
                         :new-stage)
        msg (cond-> {:stage-id stage-id}
              new-stage-id (assoc :new-stage-id new-stage-id))]
    (swap! state assoc :process/status :process.status/processing)
    (stage-actions/*->disable msg
                              (fn [_]
                                (js/setTimeout
                                 (fn []
                                   (swap! state assoc :process/status :process.status/success))
                                 2000))
                              (fn [e]
                                (handle-delete-error! state e)))))

(defn footer-view
  [{:keys [disabled? state on-close! stage]}]
  [:<>
   [modal/left-cancel-only on-close! nil]
   [modal/right-single-button
    ::c/danger
    disabled?
    (fn [_e]
      (delete! state (:db/id stage) on-close!))
    (loc/tr :delete)
    nil]])

(defn view
  [{:keys [close-modal! _shown? _props _state _class-name _topmost?]}]
  (let [on-close! (fn []
                    (close-modal!))]
    (fn [{:keys [shown? props state class-name topmost?]}]
      (let [{:keys [stage-id]} props
            confirmed? (-> @state
                           :confirmed?
                           boolean)
            new-stage (->> @state
                           :edit
                           :new-stage
                           (get @session/entities))
            disabled? (or (not confirmed?)
                          (and (:reassignment/required? @state)
                               (or (nil? new-stage)
                                   (:common/disabled? new-stage))))
            stage (get @session/entities stage-id)]
        [processing-modal/render-modal
         {:state             state
          :shown?            (and shown? topmost?)
          :success-text      (loc/tr :success-stage-deleted)
          :on-close!         on-close!
          :class-name        class-name
          :header-class-name "zap-modal__header__salmon"
          :default-title-fn  #(loc/tr :attention)
          :default-body-fn   (partial view-body state stage-id)
          :default-footer-fn (partial footer-view
                                      {:disabled? disabled?
                                       :state     state
                                       :on-close! on-close!
                                       :stage     stage})}]))))
